export enum Gender {
  UNDEFINED = 'UNDEFINED',
  MALE = 'MALE',
  FEMALE = 'FEMALE',
}

export enum RacialDenomination {
  UNDEFINED = 'UNDEFINED',
  WHITE = 'WHITE',
  BROWN = 'BROWN',
  BLACK = 'BLACK',
  ORIENTAL = 'ORIENTAL',
  INDIGENOUS = 'INDIGENOUS',
}

export interface PreassureMeasurement {
  systolic: number;
  diastolic: number;
}

export interface WorkflowMeasurements {
  bloodO2Saturation: number;
  bloodPreassure: PreassureMeasurement;
  bpm: number;
  respiratoryRate: number;
  glucose: number;
}

export interface WorkflowStudy {
  tags: string[];
  phone: string[];
  oximeterModel: string[];
  pressureGaugeModel: string[];
  glucoseExtraInfo?: string[];
  extraDescription?: string;
}

export interface WorkflowPerson {
  height: number;
  weight: number;
  age: number;
  gender: Gender;
  racialDenomination: RacialDenomination;
}

export enum WavelightMode {
  ANALYSIS = 'ANALYSIS',
  APPLICATION = 'APPLICATION',
}

export enum MandatoryWorkflowField {
  VIDEO_INPUT = 'VIDEO_INPUT',
  HEIGHT_INPUT = 'HEIGHT_INPUT',
  WEIGHT_INPUT = 'WEIGHT_INPUT',
  AGE_INPUT = 'AGE_INPUT',
  GENDER_INPUT = 'GENDER_INPUT',
  RACIAL_DENOMINATION_INPUT = 'RACIAL_DENOMINATION_INPUT',
}
